import { SettingsSection } from '$common/settings-section'
import { UserListItem } from '$common/user-list-item'
import { UserStatus } from '$common/user-status'
import { useClientInviter } from '$logic/invite/react-hook'
import { openUserProfile } from '$logic/router'
import { t } from '$i18n'

export function MyInviter() {
  const inviter = useClientInviter()
  if (!inviter) return null
  return (
    <SettingsSection headerText={t('invite.yourInviter')}>
      <UserListItem
        userId={inviter}
        secondaryText={<UserStatus userId={inviter} />}
        onClick={() => openUserProfile(inviter)}
      />
    </SettingsSection>
  )
}
